// extracted by mini-css-extract-plugin
module.exports = {"zygosity-type-button-wrapper":"ZygosityTypeButton_zygosity-type-button-wrapper__FY0ed"};